import type { PersonSuggestionItem } from "@/entities/tree-person";

export const formatYears = (birthYear: number | null | undefined, deathYear: number | null | undefined): string =>
    birthYear ? `${birthYear}-${deathYear ?? ""}` : deathYear ? String(deathYear) : "";

export const getSuggestionLabel = (suggestion: PersonSuggestionItem) => {
    const { FullName, BirthYear, DeathYear } = suggestion;
    const years = formatYears(BirthYear, DeathYear);
    return years ? `${FullName} ${years}` : (FullName ?? "");
};
